import React, { Component } from "react";
import { connect } from 'react-redux'
import { post } from '../../service/index'
import './Search.css'

class Search extends React.PureComponent {

  static defaultProps = {
    marginTop: 0
  }

  constructor(props) {
    super(props)

    this.state = {
      search: ''
    }
  }


  render() {
    const { marginTop, setResult } = this.props
    return (
      <div className="search" style={{ marginTop }} >
        <div className="control has-icons-left">
          <input
            className="input"
            id='search-box'
            type="text"
            name="search"
            value={this.state.search}
            onChange={this.onSearchChange}
            onKeyDown={this.handleEnter}
          />
          <span className="icon is-small is-left">
            <img src={require('../../assets/icon/search.png')} alt='search' className='search-icon' />
          </span>
        </div>
        <button className='search-btn' onClick={this.handleSearch} >SEARCH</button>
      </div>
    );
  }

  onSearchChange = (e) => this.setState({ search: e.target.value })

  handleEnter = e => e.key === 'Enter' ? this.handleSearch() : null

  handleSearch = async () => {
    const { token } = this.props.login.user
    const { search } = this.state
    try {
      const { result } = await post('/search_conference', { search }, token)
      this.props.setResult(result)
    } catch (err) {
      console.log(err)
    }
  }

}

const mapStateToProps = (state) => ({
  login: state.login
})

export default connect(mapStateToProps)(Search)



// WEBPACK FOOTER //
// ./src/components/Search/Search.js